import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Api } from "../Api/Api";

// ✅ Inter font
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState("admin");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      if (userType === "admin") {
        const { data } = await axios.post(`${Api}admin/login.php`, {
          username,
          password,
        });
        localStorage.setItem("token", data.token);
        localStorage.setItem(
          "currentUser",
          JSON.stringify({
            type: "admin",
            username: data.admin.username,
            id: data.admin.id,
          })
        );
        navigate("/admin/dashboard1");
      } else {
        const { data } = await axios.post(`${Api}companyworker/login.php`, {
          username,
          password,
        });
        localStorage.setItem("token", data.token);
        localStorage.setItem(
          "currentUser",
          JSON.stringify({
            type: "worker",
            username: data.worker.username,
            id: data.worker.id,
          })
        );
        navigate(`/worker/quantity/${data.worker.id}`);
      }
    } catch (error) {
      console.error("Login error:", error);
      alert("Invalid credentials");
    }
  };

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    if (currentUser?.type === "admin") {
      navigate("/admin/dashboard1");
    } else if (currentUser?.type === "worker") {
      navigate(`/worker/dashboard/${currentUser.id}`);
    }
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background:
          "linear-gradient(135deg, #e6f9ec, #fefbe7, #f1fae4, #ecfdf5)",
        fontFamily: "Inter, sans-serif",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-xl w-full max-w-sm h-[530px] p-6 sm:p-7 border border-green-100 flex flex-col justify-between">
        {/* Top Section */}
        <div>
          {/* Logo / Header */}
          <div className="text-center mb-6">
            <div className="w-12 h-12 mx-auto mb-2 flex items-center justify-center rounded-full bg-[#2E7D32]/10">
              <span className="text-[#2E7D32] text-xl">
                <img src="./logo.png" />
              </span>
            </div>
            <h1 className="text-2xl font-semibold text-[#14532D]">
              Sri Murugan Ayurvedha
            </h1>
            <p className="text-sm text-gray-500 mt-1 tracking-wide">
              Secure Login Portal
            </p>
          </div>

          {/* Toggle Buttons */}
          <div className="flex gap-3 mb-5">
            <button
              onClick={() => setUserType("admin")}
              className={`flex-1 py-2.5 rounded-md text-sm font-medium transition-all ${
                userType === "admin"
                  ? "bg-[#2E7D32] text-white shadow"
                  : "border border-gray-300 text-gray-700 hover:bg-gray-50"
              }`}
            >
              Admin
            </button>
            <button
              onClick={() => setUserType("worker")}
              className={`flex-1 py-2.5 rounded-md text-sm font-medium transition-all ${
                userType === "worker"
                  ? "bg-[#2E7D32] text-white shadow"
                  : "border border-gray-300 text-gray-700 hover:bg-gray-50"
              }`}
            >
              Worker
            </button>
          </div>

          {/* Username */}
          <div className="mb-4">
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Username
            </label>
            <input
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder={
                userType === "admin" ? "admin" : "Enter worker username"
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#2E7D32]"
            />
          </div>

          {/* Password */}
          <div className="mb-5">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={
                userType === "admin" ? "admin123" : "Enter worker password"
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#2E7D32]"
            />
          </div>

          {/* Submit */}
          <button
            onClick={handleLogin}
            className="w-full py-2.5 bg-[#2E7D32] hover:bg-[#14532D] text-white rounded-md text-sm font-medium transition-all shadow"
          >
            Login as {userType === "admin" ? "Admin" : "Worker"}
          </button>
        </div>
      </div>
    </div>
  );
}
